import React, { useState } from 'react';
import { ScrollView, TextInput, View, Text } from 'react-native';
import { Button, CustomKeyboardAvoidingView, Hr, InfoBox, Link } from 'LocalGluons';
import { func, string } from 'prop-types';
import { t } from 'Locale';
import theme from 'Theme';

import defaultStyles from '../PageStyles.jss';

const VerifyCode = ({ onSubmitted, onGetHelp, errorMessage, navigation }) => {
    const [verificationCode, setVerificationCode] = useState('');

    const onCodeSubmit = () => {
        onSubmitted(verificationCode);
    };
    const close = () => {
        navigation.pop();
    };

    return (
        <CustomKeyboardAvoidingView>
            <View style={{ flex: 1 }}>
                <ScrollView
                    contentContainerStyle={defaultStyles.container}
                    keyboardShouldPersistTaps="handled"
                >
                    <Text style={defaultStyles.title}>{t('COMMON.ENTER_CODE')}</Text>
                    <Hr />
                    {errorMessage && (
                        <InfoBox style={defaultStyles.infoBox} message={errorMessage} />
                    )}
                    <Text style={defaultStyles.description}>{t('COMMON.ENTER_CODE_MSG')}</Text>
                    <TextInput
                        style={defaultStyles.input}
                        placeholder={t('COMMON.VERIFICATION_CODE')}
                        placeholderTextColor={theme.placeholderTextColor}
                        onChangeText={setVerificationCode}
                        value={verificationCode}
                        autoCapitalize="none"
                        returnKeyType="done"
                        onSubmitEditing={onCodeSubmit}
                    />
                    <View style={defaultStyles.buttonWidth}>
                        <Button
                            style={defaultStyles.button}
                            title={t('COMMON.CONFIRM')}
                            onPress={onCodeSubmit}
                        />
                    </View>

                    <View style={defaultStyles.buttonWidth}>
                        <Button
                            onPress={close}
                            style={defaultStyles.buttom}
                            title={t('PARTNER.VOYO.CLOSE_BTN')}
                            isSecondary
                        />
                    </View>
                    <Link
                        style={defaultStyles.link}
                        label={t('VERIFY_CODE.GET_HELP')}
                        onPress={onGetHelp}
                    />
                </ScrollView>
            </View>
        </CustomKeyboardAvoidingView>
    );
};

VerifyCode.defaultProps = {
    errorMessage: null
};

VerifyCode.propTypes = {
    errorMessage: string,
    onSubmitted: func.isRequired,
    onGetHelp: func.isRequired
};

export default VerifyCode;
